import { render } from "./PartView.vue?vue&type=template&id=28706f92&scoped=true"
import script from "./PartView.vue?vue&type=script&lang=js"
export * from "./PartView.vue?vue&type=script&lang=js"

import "./PartView.vue?vue&type=style&index=0&id=28706f92&scoped=true&lang=css"

import exportComponent from "C:\\Users\\WONHAP\\Websites\\aswo-api\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28706f92"]])

export default __exports__